/**
 * @fileoverview Nav action validation.
 */

import type { ValidationResult, NavActionValidationInput } from "./types";

/**
 * Validate nav action options.
 */
export function validateNavAction(
  options: NavActionValidationInput,
): ValidationResult {
  const errors: string[] = [];

  // Title validation (required, non-empty)
  if (!options.title) {
    errors.push("Nav action title is required");
  } else if (typeof options.title !== "string") {
    errors.push("Nav action title must be a string");
  }

  // Value validation (required, non-empty)
  if (!options.value) {
    errors.push("Nav action value is required");
  } else if (typeof options.value !== "string") {
    errors.push("Nav action value must be a string");
  }

  // subTitle validation (optional)
  if (options.subTitle !== undefined && options.subTitle !== null) {
    if (typeof options.subTitle !== "string") {
      errors.push("Nav action subTitle must be a string");
    }
  }

  // icon validation (optional)
  if (options.icon !== undefined && options.icon !== null) {
    if (typeof options.icon !== "string") {
      errors.push("Nav action icon must be a string");
    }
  }

  // disabled validation (optional)
  if (options.disabled !== undefined && options.disabled !== null) {
    if (typeof options.disabled !== "boolean") {
      errors.push("Nav action disabled must be a boolean");
    }
  }

  // Extended actions validation (optional)
  if (
    options.extendedActions !== undefined &&
    options.extendedActions !== null
  ) {
    if (!Array.isArray(options.extendedActions)) {
      errors.push("Nav action extendedActions must be an array");
    } else {
      options.extendedActions.forEach((action: unknown, index: number) => {
        if (typeof action !== "object" || action === null) {
          errors.push(`Extended action at index ${index} must be an object`);
          return;
        }
        const ext = action as {
          title?: unknown;
          subTitle?: unknown;
          value?: unknown;
          icon?: unknown;
          disabled?: unknown;
        };
        if (!ext.title || typeof ext.title !== "string") {
          errors.push(
            `Extended action at index ${index} is missing required "title" property`,
          );
        }
        if (!ext.value || typeof ext.value !== "string") {
          errors.push(
            `Extended action at index ${index} is missing required "value" property`,
          );
        }
        if (ext.subTitle !== undefined && typeof ext.subTitle !== "string") {
          errors.push(
            `Extended action at index ${index} subTitle must be a string`,
          );
        }
        if (ext.icon !== undefined && typeof ext.icon !== "string") {
          errors.push(
            `Extended action at index ${index} icon must be a string`,
          );
        }
        if (ext.disabled !== undefined && typeof ext.disabled !== "boolean") {
          errors.push(
            `Extended action at index ${index} disabled must be a boolean`,
          );
        }
      });
    }
  }

  return { valid: errors.length === 0, errors };
}
